import { render, staticRenderFns } from "./EUProjects.vue?vue&type=template&id=719ed7a4"
var script = {}
import style0 from "./EUProjects.vue?vue&type=style&index=0&id=719ed7a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports